import { useState, useEffect, useCallback } from 'react'
import { Product } from '../types/product'
import { ApiService } from '../services/api'
import { analytics, productToEventItem } from '../analytics'

export const useSearch = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState<Product[]>([])
  const [isSearching, setIsSearching] = useState(false)
  const [searchError, setSearchError] = useState<string | null>(null)

  const searchProducts = useCallback(async (query: string) => {
    if (!query.trim()) {
      setSearchResults([])
      return
    }

    try {
      setIsSearching(true)
      setSearchError(null)
      
      const results = await ApiService.searchProducts(query, 20)
      setSearchResults(results)
      analytics.track('search', {
        search_term: query,
        items: results.slice(0, 10).map(p => productToEventItem(p)),
      })
    } catch (error) {
      setSearchError('Помилка пошуку')
      setSearchResults([])
    } finally {
      setIsSearching(false)
    }
  }, [])

  const clearSearch = useCallback(() => {
    setSearchQuery('')
    setSearchResults([])
    setSearchError(null)
  }, [])

  // Автоматичний пошук при зміні запиту (з затримкою)
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchQuery.trim()) {
        searchProducts(searchQuery)
      } else {
        setSearchResults([])
      }
    }, 300) // Затримка 300мс

    return () => clearTimeout(timeoutId)
  }, [searchQuery, searchProducts])

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    isSearching,
    searchError,
    searchProducts,
    clearSearch,
  }
}
